import {
  ActionAndClause,
  AggregatedSSOMappingsAPIResponse,
  SSOAttributeMappingAPIResponse,
  SSOAttributeMappingPreviewAPIResponse,
} from '@ardoq/api-types';
import { Method, crudApi, fetchJson, toRequestOptions } from './api';
import { ApiResponse } from './types';

const postPreview = (body: {
  mappings: ActionAndClause[];
  provider?: string;
}): ApiResponse<SSOAttributeMappingPreviewAPIResponse> => {
  const request = new Request(
    '/api/sso-mapping/preview/preview',
    toRequestOptions(Method.POST, body)
  );
  return fetchJson<SSOAttributeMappingPreviewAPIResponse>(request);
};

const fetchAggregated = (): ApiResponse<AggregatedSSOMappingsAPIResponse> => {
  const request = new Request(
    `/api/sso-mapping/aggregated/entries`,
    toRequestOptions(Method.GET, null)
  );
  return fetchJson<AggregatedSSOMappingsAPIResponse>(request);
};

export const SSOMappingApi = {
  ...crudApi<SSOAttributeMappingAPIResponse>('sso-mapping'),
  postPreview,
  fetchAggregated,
};
